import React, { Component } from 'react';

export default class NoMatch extends Component{
  constructor(){
    super();

    // default timeout 5 seconds
    this.state = { counter: 5 };
  }

  // redirects to homepage after a few seconds
  componentDidMount(){
    var id = setInterval( ()=> {
      var val = this.state.counter - 1;

      if ( this.state.counter === 1 ){
        clearInterval(id);
        window.location = '/';
      }
      console.log(val);
        this.setState({ counter: val });
      }, 1000);
  }


  render(){
    return(
      <div className="row section">
        <div className="col-sm-12">
          <div className="section panel">
            <h2>Page non Trouv&eacute;e</h2>
            <p>Nous vous dirigeons vers la page d'accueil...{ this.state.counter }</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/err/NoMatch.js